export default __webpack_public_path__ + "static/gaming-5ad84b23390ca16e90021ca640fa0796.png";